import Vue from 'vue'
import Router from 'vue-router'
import { isEmpty } from "../utils/filter";
// import home from '@/components/home'
import https from "../utils/https";
import qs from "qs";

const home =() => import("../components/Home")
const usercenter = () => import("@/components/usercenter");
const wxAuth = () => import("@/components/wxAuth/Auth");
const newcard =() => import("@/components/User/CreateCard");
const register =() => import("@/components/Register/Register");
const reglist =() => import("@/components/Register/RegisterList");
const doclist =() =>import("@/components/Register/DocList")
const cardInfo =() => import("@/components/User/CardInfo")
const lis =() =>import("../components/Report/Lis")
const pacs =() =>import("../components/Report/Pacs")
const visitRecord =() =>import("../components/Visit/VisitRecord")
const registerInfo =() =>import("../components/Register/RegisterInfo")
const payReg =() => import("../components/Register/PayRegister")
const iteminfo =() => import("../components/hospital/SelectItem")
const paylis =() => import("../components/Payment/PayRecord")
const inhospital =() => import("../components/Inhospital/Inhospital")
const recharge =() => import("../components/Inhospital/Recharge")
const inhospitallist =() => import("../components/Inhospital/InhospitalList");
const lisinfo =() => import("../components/Report/LisInfo")
const hospitalinfo =() =>import("../components/hospital/hospitalinfo")
const rechargelist =() =>import("../components/Inhospital/RechargeList")
const map =() =>import("../components/hospital/HospitalMap")
const paydetail =() =>import("../components/Payment/PayDetail")
const registerdetail =()=>import("../components/Register/RegisterDetail")
const yyregisterinfo =()=>import("../components/Register/YYRegisterInfo")
const yyReginfoList =()=>import("../components/Register/YYRegisterList")
const paySuccess=()=>import("../components/Payment/PaySuccess")
const yyRegSuccess =()=>import("../components/Register/YYRegisterSuccess")
const hosguide=()=>import("../components/hospital/Hospitalguide")
const appraise =()=>import("../components/hospital/Appraise")
const userindex=()=>import("../components/User/UserIndex.vue")
const user =()=>import("../components/User/MyUser.vue")
const outrecharge =() =>import("../components/OutRecharge/Recharge")
const outrechargeinfo=()=>import("../components/OutRecharge/RechargeInfo")
const payinfos =() => import("../components/Payment/PayInfos.vue")
const paylists =() =>import("../components/Payment/PayList.vue")
const docinfo =() => import("../components/Doctor/Doctorinfo")
const collectionlist =() => import("../components/Doctor/CollectionList")
const xinfeng =() => import("../components/hospital/SubmitAppraise")
const wswinfo =() => import("../components/Report/WswInfo")
const takeOrder =() =>import("../components/Nucleicacid/TakeOrder")
const cardPay =() =>import("../components/Common/CardPay")
const checkorder =() =>import("../components/Nucleicacid/CheckOrder")
const cardlist =() =>import("../components/User/CardList")
const cert = () => import("../components/Chaperonage/EscortCert")
const hosinfo = () => import("../components/Inhospital/InHosInfo")
const addcert = () => import("../components/Chaperonage/AddCert.vue")
const ybpatinfo =() => import("../components/Yibao/PatientInfo.vue")
const ybpay = () => import("../components/Yibao/YBPay.vue")
const ybpayment =() => import("../components/Yibao/ybPaymentInfo.vue")

Vue.use(Router)

var router =  new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path:'/usercenter',
      name:'usercenter',
      component:user
    },
    {
      path:'/wxAuth',
      name:'wxAuth',
      component:wxAuth
    },
    {
      path:'/newcard',
      name:'newcard',
      component:newcard
    },
    {
      path:'/register',
      name:'register',
      component:register
    },
    {
      path:'/reglist',
      name:'reglist',
      component:reglist
    },
    {
      path:'/cardinfo',
      name:'cardinfo',
      component:cardInfo
    },
    {
      path:'/lis',
      name:lis,
      component:lis
    },
    {
      path:'/pacs',
      name:pacs,
      component:pacs
    },
    {
      path:'/visitrecord',
      name:visitRecord,
      component:visitRecord
    },
    {
      path:'/doclist/:deptid',
      name:doclist,
      component:doclist
    },
    {
      path:'/reginfo',
      name:registerInfo,
      component:registerInfo
    },{
      path:'/payreg',
      name:payReg,
      component:payReg
    },{
      path:'/iteminfo',
      name:iteminfo,
      component:iteminfo
    },
    {
      path:'/paylist',
      name:paylis,
      component:paylis
    },
    {
      path:'/inhospital',
      name:inhospital,
      component:inhospital
    },
    {
      path:'/recharge',
      name:recharge,
      component:recharge
    },
    {
      path:'/inhospital-list',
      name:inhospitallist,
      component:inhospitallist
    },
    {
      path:'/lis-detail',
      name:lisinfo,
      component:lisinfo
    },
    {
      path:'/hospital',
      name:hospitalinfo,
      component:hospitalinfo
    },
    {
      path:'/recharge-list',
      name:rechargelist,
      component:rechargelist
    },
    {
      path:'/hospital-map',
       name:map,
       component:map
    },
    {
      path:'/pay-detail',
      name:paydetail,
      component:paydetail
    },
    {
      path:'/register-detail',
      name:registerdetail,
      component:registerdetail
    },
    {
      path:'/yyReginfo',
      name:yyregisterinfo,
      component:yyregisterinfo
    },
    {
      path:'/yyRegList',
      name:yyReginfoList,
      component:yyReginfoList
    },
    {
      path:'/pay-success',
      name:paySuccess,
      component:paySuccess
    },
    {
      path:'/yyreg-success',
      name:yyRegSuccess,
      component:yyRegSuccess
    },
    {
      path:'/hos-guide',
      name:hosguide,
      component:hosguide
    },
    {
      path:'/appraise',
      name:appraise,
      component:appraise
    },
    {
      path:'/userindex',
      name:userindex,
      component:userindex
    },
    {
      path:'/user',
      name:user,
      component:usercenter
    },
    {
      path:'/out_recharge',
      name:outrecharge,
      component:outrecharge
    },
    {
      path:'/out_rechargelist',
      name:outrechargeinfo,
      component:outrechargeinfo
    },
    {
      path:'/payinfo',
      name:payinfos,
      component:payinfos
    },
    {
      path:'/pay-list',
      name:paylists,
      component:paylists
    },
    {
      path:"/docinfo",
      name:docinfo,
      component:docinfo
    },
    {
      path:"/collection-list",
      name:collectionlist,
      component:collectionlist
    },
    {
      path:'/xinfeng',
      name:xinfeng,
      component:xinfeng
    },
    {
      path:'/wswinfo',
      name:wswinfo,
      component:wswinfo
    },
    {
      path:'/take_order',
      name:takeOrder,
      component:takeOrder
    },
    {
      path:'/cardpay',
      name:cardPay,
      component:cardPay
    },
    {
      path:'/checkorder',
      name:checkorder,
      component:checkorder
    },
    {
      path:'/cardlist',
      name:cardlist,
      component:cardlist
    },
    {
      path:'/cert',
      name:cert,
      component:cert
    },
    {
      path:'/hosinfo',
      name:hosinfo,
      component:hosinfo
    },
    {
      path: '/addcert',
      name: addcert,
      component:addcert
    },
    {
      path: '/ybpatinfo',
      name: ybpatinfo,
      component:ybpatinfo
    },
    {
      path: '/ybpay',
      name: ybpay,
      component:ybpay
    },
    {
      path: '/ybpayment',
      name: ybpayment,
      component:ybpayment
    },
  ],
  mode:'history'
})


router.beforeEach((to, from, next) => {
  // if (process.env.NODE_ENV === "development") {
  //   Cookies.set("token", "z5cfKme49g1e08kbxcR8fsqsumfLxN95TBW1hg/nRDY=");
  //   localStorage.setItem("name", "常玉坤");
  // }
  // 不要对 WxAuth 路由进行拦截，不进入 WxAuth 路由就拿不到微信返回的授权 code
  // 在跳转前判断页面是否有缓存，如果有则清除
  if (to.meta.clearCache) {
    sessionStorage.clear()
  }
  next();
  if(to.path.indexOf("/api/")>0){
    next();
    return;
  }
  if (to.name === "wxAuth") {
    next();
    return;
  }
  if (to.name === "alipayingredict") {
    next();
    return;
  }
  let urlHost = process.env.API_HOST
  let token = localStorage.getItem("token");
  // console.log("token："+token);
 if (isEmpty(token)) {
    // 保存当前路由地址，授权后还会跳到此地址
    console.log(to.fullPath);
    sessionStorage.setItem("wxRedirectUrl", to.fullPath);
    https.Post(urlHost+"Wechat/GetAuthCode").then(res => {
      console.log("res"+res);
      if (res.Status == "success") {
        console.log(res);
        window.location.href = res.Data;
      } else {
        next();
      }
  });

  // var paramObj={
  //   httpUrl:urlHost+"Wechat/GetAuthCode",
  //   type:'post',
  // }
  // https.httpRequest(paramObj,function(res){
  //   var resData=JSON.parse(res)
  //       if (resData.Status == "success") {
  //       window.location.href = resData.Data;
  //     } else {
  //       next();
  //     }
  // });
 } else {
  next();
 }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js